<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
    post: {
        type: Object,
        required: true
    }
});

const store = useStore();

const postImage = computed(() => {
    return props.post.image_lg || props.image || props.post.image || '';
});

const postLink = computed(() => {
    const appType = store.getters['settings/getApplicationType'];

    return appType === 'backend' ? '/dashboard/hkcmnews/' + props.post.slug.name : '/hkcmnews/' + props.post.slug.name;
});
</script>

<template>
    <router-link
        class="cursor-pointer group border-b border-pimary rounded-md shadow-md hover:shadow-xl transition-all ease-in-out relative bg-white block h-full border-2 border-blue"
        :to="postLink">
        <div v-if="postImage" class="w-full aspect-video shrink-0">
            <img :src="postImage" class="w-full h-full object-cover rounded-t-md shadow-md" />
        </div>

        <div class="p-2">
            <div class="block items-center justify-between">
                <div v-if="post.user" class="transition-all ease-in-out">
                    <div class="flex flex-row gap-2 items-center">
                        <img v-if="post?.authorbox?.portrait" class="w-12 h-12 rounded-full object-cover bg-blue"
                            :src="post.authorbox.portrait" :alt="post.user.name" />
                        <div class="text-sm">
                            <p style="line-height: 100%">{{ $t('author_male') }}:</p>
                            <strong>
                                {{ post.user.name }}
                            </strong>
                        </div>
                    </div>
                </div>

                <div v-if="post.postCategories && post.postCategories.data.length" class="inline-flex flex-wrap mt-1">
                    <div v-for="category in post.postCategories.data.slice(0, 5)" :key="category.id"
                        class="border border-blue text-blue text-xs px-1.5 rounded-full">
                        {{ $translate(category.name) }}
                    </div>
                </div>
            </div>
            <div class="flex flex-row gap-4 mt-2">
                <div class="w-full flex flex-col justify-between gap-2">
                    <h3 class="base_bold">
                        {{ $translate(post.title) }}
                    </h3>
                </div>
            </div>
        </div>
    </router-link>
</template>
